export default {
    aggregateToolbar: {
        from: 'OD',
        to: 'DO',
        countryFilter: 'Filter države',
        showSplit: 'Prikaži razdelitev (napoved vs futures)',
        nothingToSplitTitle: 'Ni napovedi za to obdobje — ni kaj razdeliti',
    },
}
